import React from 'react';
import { Route } from 'react-router';

import Page from './component';

export default <Route
    exact
    key="reset-password"
    path="/user-reset-password/:uid/:token"
    component={Page} />;